module.exports = __webpack_public_path__ + "static/media/23.11aa8f96.jpg";